import React from "react";

import { 
  Row,
  Col,
} from "antd";

 export default function UserAddress(props){
    return <>
    {props&&props.address
        ? props.address.map((item) => {
          return (
            
            <div>
              <p className='mi_address_card'>{item.address_Type_Name}</p>
              
            <Row>
              <Col md={4} sm={24}>
                <p className="mi_name">Address 1</p>
                <p className="mi_value">{item.street}</p>
              </Col>
              <Col md={4} sm={24}>
                <p className="mi_name">Address 2</p>
                <p className="mi_value">{item.street1 ? item.street1 : 'none'}</p>
              </Col>
              <Col md={3} sm={24}>
                <p className="mi_name">City</p>
                <p className="mi_value">{item.city}</p>
              </Col>

              <Col md={3} sm={24}>
                <p className="mi_name">State</p>
                <p className="mi_value">{item.stateName}</p>
              </Col>
              <Col md={3} sm={24}>
                <p className="mi_name">Country</p>
                <p className="mi_value">United States</p>
              </Col>
              <Col md={3} sm={24}>
                <p className="mi_name">ZIP</p>
                <p className="mi_value">{item.zipCode&&item.zipCode.length === 5 ? item.zipCode : item.zipCode&&item.zipCode.length ===10 ? item.zipCode : "Invalid Zip"}</p>
              </Col>

              <Col md={3} sm={24}>
                <p className="mi_name">Is Default Address</p>
                <p className="mi_value">{item.isprimaryAcc ? "YES" : "NO"}</p>
              </Col>
              
            </Row>
            
          </div>
          );
        }) : ''}</>;
};